import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { categoriesSelector, getCategoryFiltersList } from '../feature';

const useGetFiltersList = () => {
  const dispatch = useAppDispatch();
  const { isLoadingFiltersList, error, filtersList } = useAppState(categoriesSelector);

  useEffect(() => {
    dispatch(getCategoryFiltersList({}));
  }, [dispatch]);

  return { filtersList, isLoadingFiltersList, error };
};

export default useGetFiltersList;
